export default function WhyBuyLeads() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-100 to-teal-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-lightbulb-flash-line"></i>
            Pourquoi Investir dans des Demandes Qualifiées ?
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent mb-6">
            Des Clients Prêts à Acheter, Livrés Directement Chez Vous
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transformez votre activité de menuiserie avec des clients prêts à acheter
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
              <i className="ri-money-euro-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Un Panier Moyen de 350€ par Client
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Nos leads concernent des projets de <strong>réparation de fenêtres</strong>, <strong>baies vitrées</strong> et <strong>volets roulants</strong> avec un budget moyen de 350€. Chaque lead représente une opportunité concrète de chiffre d'affaires.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <div>
                  <p className="text-gray-700"><strong>Clients avec budget confirmé</strong> - Pas de perte de temps avec des prospects non qualifiés</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <div>
                  <p className="text-gray-700"><strong>Demandes urgentes</strong> - Fenêtres cassées, volets bloqués nécessitant intervention rapide</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-600"></i>
                </div>
                <div>
                  <p className="text-gray-700"><strong>Projets variés</strong> - Réparations simples aux installations complètes</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-3xl p-8 border border-orange-200 shadow-xl">
              <div className="space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-gray-600 font-medium">Réparation Fenêtre PVC</span>
                    <i className="ri-window-line text-2xl text-orange-600"></i>
                  </div>
                  <div className="text-3xl font-bold text-gray-900">280 - 450€</div>
                  <p className="text-sm text-gray-500 mt-2">Remplacement vitrage + mécanisme</p>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-gray-600 font-medium">Volet Roulant Électrique</span>
                    <i className="ri-layout-row-line text-2xl text-orange-600"></i>
                  </div>
                  <div className="text-3xl font-bold text-gray-900">420 - 680€</div>
                  <p className="text-sm text-gray-500 mt-2">Installation moteur + télécommande</p>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-gray-600 font-medium">Baie Vitrée Coulissante</span>
                    <i className="ri-door-open-line text-2xl text-orange-600"></i>
                  </div>
                  <div className="text-3xl font-bold text-gray-900">650 - 950€</div>
                  <p className="text-sm text-gray-500 mt-2">Réparation rail + remplacement joint</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl p-12 border border-teal-200 shadow-xl">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-star-line"></i>
              Les Avantages Concrets pour Votre Entreprise
            </div>
            <h3 className="text-3xl font-bold text-gray-900">
              Développez Votre Activité Sans Effort
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Gagnez du Temps</h4>
              <p className="text-gray-600">
                Fini la prospection téléphonique et les démarchages. Concentrez-vous sur votre métier : la menuiserie et la réparation.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Augmentez Votre CA</h4>
              <p className="text-gray-600">
                Avec un panier moyen de 350€, un seul lead converti par semaine représente 18 000€ de CA annuel supplémentaire.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Clients Vérifiés</h4>
              <p className="text-gray-600">
                Chaque demande est qualifiée et vérifiée. Vous contactez uniquement des clients sérieux et motivés.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}